import React, { useState, useEffect } from 'react';
import SideNavBar from './SideNavBar';
import NavBarMain from './NavBarMain';
import { useNavigate } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import axios from ".././axios-interceptor";
import moment from "moment";
import {
  base_url,
  STATUS_NEW,
  STATUS_IN_PROGRESS,
  STATUS_PROCESSED,
  STATUS_REJECTED,
  STATUS_APPROVED,
  SERVICE_REQUEST_NEW_LOAN,
  SERVICE_REQUEST_EXTEND_TENURE,
  SERVICE_REQUEST_PRE_CLOSURE,
  SERVICE_REQUEST_PARTIAL_PRE_PAYMENT,
  STATUS_CLOSED,
  LOAN_REPAYMENT_BY_BUSINESS,
} from "../utilities";
import { ThreeDots } from "react-loader-spinner";
import { Table } from "react-bootstrap";
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';

const BusinessProfile = () => {
  const navigate = useNavigate();
  const [uploadBtn, setUploadBtn] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [selectedFile, setSelectedFile] = useState("");
  const [imageUrl, setImageUrl] = useState('');
  const [businessProfileData, setBusinessProfileData] = useState([]);
  const [kycDocuments, setKYCDocuments] = useState([]);
  const [loanhistory, setLoanHistory] = useState([]);

  const titles = ["Type", "Uploaded By", "Actions"];
  useEffect(() => {

    axios
      .post(base_url + "business-master/get_business_by_business_id", {
        "business_id":  Cookies.get("business_id"),
      })
      .then((res) => {
        let data = res.data.data;
        if (data === '') {
          setIsLoading(true)
        }
        else {
          if (data.business_image_url == null || data.business_image_url == "") {
            data.business_image_url = "https://media.istockphoto.com/id/1256603011/photo/business-network-concept-customer-support-shaking-hands.jpg?s=612x612&w=0&k=20&c=uRYJ6c2EyNO92w0wQlCScEVwbdoyHaXzfIxw1q7zNLA="
          }
          setBusinessProfileData(data)
          setKYCDocuments(data.list_of_kyc_documents);
          setLoanHistory(data.business_loans_history);
        }
      })


  }, [])

  let loanhistorydata = loanhistory;
  let loan_history_array = [];
  loanhistorydata?.map(each_history_record => {
    //NEW LOAN REQUEST LIST
    if (each_history_record.status == STATUS_NEW && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Business requested loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if ((!each_history_record.is_investor_interested) && (!each_history_record.is_admin_sent_terms_to_business)) {
      if (each_history_record.status == STATUS_IN_PROGRESS && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
        let message = "Admin filled the profit percentage and sent to investors";
        let created_date_time = each_history_record.created_date_time;
        let message_object = {
          message: message,
          created_date_time: created_date_time
        }
        loan_history_array.push(message_object)
      }
    }
    if (each_history_record.status == STATUS_REJECTED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Admin rejected the new loan request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_IN_PROGRESS && each_history_record.is_investor_interested === 1 && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Investor has shown interest on this loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_IN_PROGRESS && each_history_record.is_admin_sent_terms_to_business === 1 && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Admin sent loan terms and awaiting for business response";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }

    if (each_history_record.status == STATUS_APPROVED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Business agreed the new loan request terms";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }

    if (each_history_record.status == STATUS_PROCESSED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = (
        <div className='style_loan_txt'>
          Admin paid the requested loan amount <span style={{ color: "black", marginTop: "2px" }} className="ps-1 pe-1 fw-bold">{each_history_record.paid_currency + " " + Number(each_history_record.paid_amount).toLocaleString()}</span> to business on <span style={{ color: "black", marginTop: "2px" }} className="ps-1 pe-1 fw-bold">{moment(each_history_record.paid_date).format('DD MMM YYYY')}</span>
        </div>
      );
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == LOAN_REPAYMENT_BY_BUSINESS && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message =

        <div className=''>
          Business repaid for the month of <span style={{ color: "black" }} className=" fw-bold">{moment(each_history_record.tenure_date).format('MMMM')}</span>, loan tenure amount <span style={{ color: "black" }} className="fw-bold">{each_history_record.paid_currency + " " + Number(each_history_record.paid_amount).toLocaleString()}</span> to admin on <span style={{ color: "black" }} className="fw-bold">{moment(each_history_record.paid_date).format('DD MMM YYYY')}</span>
        </div>
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }


    if (each_history_record.status == STATUS_NEW && each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
      let message = "Business requested to extend loan tenure";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_APPROVED && each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
      let message = "Admin approved extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }


    if (each_history_record.status == STATUS_REJECTED && each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
      let message = "Admin rejected the extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }


    if (each_history_record.status == STATUS_NEW && each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
      let message = "Business requested for pre closure of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_APPROVED && each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
      let message = "Admin approved pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_REJECTED && each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
      let message = "Admin rejected pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Business requested for partial pre-payment of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin approved partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin rejected partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (each_history_record.status == STATUS_CLOSED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Business repaid the loan successfully"
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
  })

  const handleDownload = async (url, document_type) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = businessProfileData.business_name + "_" + document_type; // file name
      a.click();
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      console.log(err)
    }
  };
  useEffect(() => {
  if (!Cookies.get("User_Accesstoken_Business")) {
    navigate('/');
  }
}, []);
  const [imgFlag, setImgFlag] = useState(false)

  const handleEditProfile = () => {
    setUploadBtn(true)

  }
  const [file, setUploadFile] = useState(null); //setUploadedUrl
  const [url, setUploadedUrl] = useState(null);
  const handleFileInputChange = (e) => {
    const fileName = e.target.files[0].name;
    const lastDotIndex = fileName.lastIndexOf('.');
    const fileExtension = fileName.substring(lastDotIndex + 1);
    if (fileExtension == "png" || fileExtension == "jpeg" || fileExtension == "jpg"|| fileExtension == "svg") {
      setImgFlag(true)
      setSelectedFile(URL.createObjectURL(e.target.files[0]));
      const url = URL.createObjectURL(e.target.files[0]);
      setImageUrl(url);
      setUploadFile(e.target.files[0].name);
      setUploadedUrl(e.target.files[0]);
    }
    else {
      toast.error("Please upload a profile in either SVG, PNG or JPEG format.", { toastId: 98 })
    }
  }
  const handleSaveChanges = () => {
    if(url !=null){
    setUploadBtn(false)
    const fd1 = new FormData();
    fd1.append('updated_by', Cookies.get("user_name"))
    fd1.append('business_id',  Cookies.get("business_id"));
    const fileName = file;
    const lastDotIndex = fileName.lastIndexOf('.');
    const fileExtension = fileName.substring(lastDotIndex + 1);
      fd1.append('file', url, fileExtension);
    axios.post(base_url + "business-master/update_business_profile_image", fd1, {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
  }).then((res) => {
      toast.success("Image uploaded successfully", {
        toastId: 90,
      });
      setTimeout(() => {
        window.location.reload();
      });
    })
  }
  else{
    toast.error("Please upload a profile picture", { toastId: 98 })
  }
  }
  const handleCancelChanges =()=>{
    setUploadBtn(false)
  }
  let splitdata;
  let aboutdata = businessProfileData.about;
  if (aboutdata !== undefined) {
    splitdata = aboutdata.split(". ");
  }


  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      <SideNavBar />
      <main style={{ width: "100%" }}>
        <NavBarMain />

        {isLoading ?
          <div className="historyLoader">
            <ThreeDots
              height="90"
              width="90"
              radius="9"
              color="#3d79f3"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={isLoading}
            />
          </div> :



          <div className='p-3 pe-4 ps-4 db_body'>
            <div className='titleplusedit'>
              <h1>Profile Page</h1>
              <div className='d-flex gap-3'>
                {!uploadBtn && <button className="blue_btn px-4" onClick={handleEditProfile}>Edit</button>}
                {uploadBtn && <button className="blue_btn  px-4" onClick={handleCancelChanges}>Cancel</button>}
                {uploadBtn && <button className="gray_btn px-4" onClick={handleSaveChanges}>Save</button>}
              </div>
            </div>
            <div className='profile_maindiv2'>
              <div className="">
                <Card className=" d-flex justify-content-between">
                  <div className="row ">
                    <div className='col m-3 d-flex align-items-center justify-content-center' >

                      <div className='busprofMaintitle'>
                        <h4 className='' >{businessProfileData.business_name}</h4>
                        <div className='busproftitle'><p><b>Industry:</b> {businessProfileData.business_type} </p></div>
                      </div>
                  
                    </div>
                    <div className='col m-3 container image_uploadbtndiv' >
                      <img srcSet={imgFlag ? selectedFile : businessProfileData.business_image_url} alt="" />

                      <label className="Cpointer " >
                        {uploadBtn &&
                          <div>
                            <input type="file" onChange={(e) => handleFileInputChange(e)} />
                            <span className="blue_btn"><img src={"./images/upload.svg"} alt="" /> Upload New</span>
                          </div>}</label>


                    </div>
                  </div>
                </Card>
              </div>
              <div className=" profileBusDetailstab">
                <div className="">
                  <ul
                    className="nav nav-tabs d-flex"
                    id="myTab"
                    role="tablist"
                  >

                    <li className="nav-item-indiv-busns" role="presentation">
                      <button
                        className="nav-link-settingsProf p-1 active"
                        id="About-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#About-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="About-tab-pane"
                        aria-selected="true"
                      >
                        <h3>About</h3>
                      </button>
                    </li>
                    <li className="nav-item-indiv-busns" role="presentation">
                      <button
                        className="nav-link-inv p-1"
                        id="Financials-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#Financials-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="Financials-tab-pane"
                        aria-selected="false"
                      >
                        <h3>KYC Documents</h3>
                      </button>
                    </li>


                    <li className="nav-item-indiv-busns" role="presentation">
                      <button
                        className="nav-link-inv p-1"
                        id="loanhistory-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#loanhistory-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="loanhistory-tab-pane"
                        aria-selected="false"
                      >
                        <h3>Loan History</h3>
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="tab-content " id="myTabContent">

                  <div
                    className="tab-pane fade show active line_height_about_inv"
                    id="About-tab-pane"
                    role="tabpanel"
                    aria-labelledby="About-tab"
                    tabIndex="0"
                  >
                    <p className="paragraph">
                      <p className="paragraph">
                        {splitdata?.map((sentence, index) => (
                          <p key={index}>{"\n" + sentence.trim() + "."}</p>
                        ))}
                      </p>
                    </p>
                  </div>
                  <div
                    className="tab-pane fade Financials_tab"
                    id="Financials-tab-pane"
                    role="tabpanel"
                    aria-labelledby="Financials-tab"
                    tabIndex="0"
                  >
                    <div className="row allinv_doc_tab_styl">
                      <div className="">
                        <Table
                          responsive
                          striped

                          className=" my_loan_table fin"
                        >
                          <thead>
                            <tr>
                              {titles.map((title, id) => (
                                <th key={id}>{title}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {kycDocuments.map((doc, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    {doc.document_type == undefined
                                      ? "-"
                                      : doc.document_type}
                                  </td>
                                  <td>
                                    {doc.created_by == undefined
                                      ? "-"
                                      : doc.created_by}
                                  </td>
                                  <td>
                                    <div className="d-flex justify-content-evenly">
                                      <div className="">
                                        <a
                                          style={{ display: "table-cell" }}
                                          href={doc.document_url}
                                          target="_blank"
                                        >
                                          <img src="./images/eye.svg" alt="" />
                                        </a>
                                      </div>
                                      <div
                                        className=" ps-3 Cpointer"
                                        onClick={() =>
                                          handleDownload(
                                            doc.document_url,
                                            doc.document_type
                                          )
                                        }
                                      >
                                        <img src="./images/down.svg" alt="" />
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </div>


                  <div
                    className="tab-pane fade loanhistory_tab loanhistory_tab_styl"
                    id="loanhistory-tab-pane"
                    role="tabpanel"
                    aria-labelledby="loanhistory-tab"
                    tabIndex="0"
                  >
                    {loan_history_array.length === 0 ? <h3 className="text-center mt-4">There are no previous closed loans for this Business</h3> : loan_history_array.map((details) => {
                      return (
                        <div key={details.message} className="row pt-0">
                          <div className="style_loan">
                            <img
                              className="me-2"
                              src="./images/circle.svg"
                              alt=""
                              srcSet=""
                              height={16}
                              width={16}
                            />
                            {moment(details.created_date_time).format(
                              "ddd, D MMM YYYY"
                            )}
                          </div>
                          <div className="style_loan_txt mb-4 ms-4 pe-5">
                            {details.message}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>}

      </main>
    </div>
  );
};

export default BusinessProfile;